import { useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import { ConfigContext } from 'src/configContext';
import { Button } from 'src/modules/common/components/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { LocationState } from 'src/modules/LocationState';
import { PATHS } from 'src/types/Paths';

type Props = {
    actuatorLabel: string;
    page: string;
    locationState: LocationState;
    searchParams: URLSearchParams;
}

export const ValvesSelectActuatorButton = ({ actuatorLabel, page, locationState, searchParams }: Props) => {
    const { gaPush } = useContext(ConfigContext);

    const onClick = useCallback(() => {
        gaPush({
            event: 'gaEvent',
            eventCategory: 'sizing tool',
            eventAction: 'step 4 - actuator parameters',
            eventLabel: 'choose matching actuator',
        });
    }, [gaPush]);

    return (
        <Button
            onClick={onClick}
            className="vss-valves-select-actuator-button"
            as={Link}
            to={{
                pathname: [
                    PATHS.Accessories,
                    locationState.valveLabel,
                    encodeURIComponent(actuatorLabel),
                    page.toString(),
                ].join('/'),
                search: searchParams.toString(),
            }}
            state={locationState.actuatorLabel === actuatorLabel ? { ...locationState } : {
                ...locationState,
                actuatorLabel,
                actuatorsPage: page.toString(),
                selectedAccessories: [],
                combo: null,
            }}
            icon={(
                <div className="vss-valves-select-actuator-button__icon">
                    <ArrowRightIcon/>
                </div>
            )}
        >
            <I18n messageId={MESSAGES.selectDevice}/>
        </Button>
    );
};
